import { Control } from 'runtime/controls/control';
import { ControlArgs } from 'runtime/controls/controlargs';

export class LooklessControl extends Control {
    constructor(args: ControlArgs) {
        super(args);
        this.$element.hide();
    }

    focus() { }
    applyVisibleState() { }
}